import { MonthEndProcessStatus } from './month-end-process-status.enum';
import { MonthEndTaskState } from './month-end-task-state';

export class MonthEndStatusUtil {
  static fromTaskState(
    taskState: MonthEndTaskState | undefined | null,
  ): MonthEndProcessStatus {
    if (
      !taskState ||
      taskState.statusId === undefined ||
      taskState.statusId === null
    ) {
      return MonthEndProcessStatus.Pending;
    }

    return this.resolveStatus(taskState.statusId);
  }

  static fromTaskStates(
    taskStates: ReadonlyArray<MonthEndTaskState> | undefined | null,
  ): MonthEndProcessStatus {
    const list = taskStates ?? [];
    if (!list.length) return MonthEndProcessStatus.Pending;

    if (
      list.some((t) => this.fromTaskState(t) === MonthEndProcessStatus.Failed)
    ) {
      return MonthEndProcessStatus.Failed;
    }
    if (
      list.some((t) => this.fromTaskState(t) === MonthEndProcessStatus.Running)
    ) {
      return MonthEndProcessStatus.Running;
    }
    if (
      list.every(
        (t) => this.fromTaskState(t) === MonthEndProcessStatus.Completed,
      )
    ) {
      return MonthEndProcessStatus.Completed;
    }
    return MonthEndProcessStatus.Pending;
  }

  static resolveStatus(
    statusId: MonthEndProcessStatus | string | number | null | undefined,
  ): MonthEndProcessStatus {
    if (statusId === null || statusId === undefined) {
      return MonthEndProcessStatus.Pending;
    }

    if (typeof statusId === 'string') {
      const statusStr = statusId.toLowerCase();
      switch (statusStr) {
        case 'pending':
        case '1':
          return MonthEndProcessStatus.Pending;
        case 'running':
        case '2':
          return MonthEndProcessStatus.Running;
        case 'completed':
        case '3':
          return MonthEndProcessStatus.Completed;
        case 'failed':
        case '4':
          return MonthEndProcessStatus.Failed;
        default:
          return MonthEndProcessStatus.Pending;
      }
    }

    return statusId as MonthEndProcessStatus;
  }

  static isProcessRunning(taskStates: MonthEndTaskState[] | null): boolean {
    if (!taskStates || taskStates.length === 0) {
      return false;
    }

    return taskStates.some(
      (taskState) =>
        this.fromTaskState(taskState) === MonthEndProcessStatus.Running ||
        this.fromTaskState(taskState) === MonthEndProcessStatus.Failed ||
        this.fromTaskState(taskState) === MonthEndProcessStatus.Pending,
    );
  }
}
